// extracted by mini-css-extract-plugin
export var legendIndicator = "_e6-1";
export var legendRight = "_e6-0";